const getImageSrc = image => (image.childImageSharp) ? image.childImageSharp.fluid.src : image
const toggleClass = (elementId, className) => {
  let element = document.getElementById(elementId)
  if(!element) return;
  if (element.classList) {
    element.classList.toggle(className)
  } else {
    // For IE9
    let classes = element.className.split(" ")
    let i = classes.indexOf(className)

    if (i >= 0)
      classes.splice(i, 1)
    else
      classes.push(className)
    element.className = classes.join(" ")
  }
}
export { getImageSrc, toggleClass }